import { useQuery, useQueryClient } from '@tanstack/react-query'

import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'
import { QUERY_KEYS } from '@/lib/queryKeys'
import companyService from '@/lib/services/companyService'

export function useCurrentCompanyServicesQuery() {
  const currentCompany = useCurrentCompanyOrFail()

  return useQuery({
    queryKey: QUERY_KEYS.companyServices(currentCompany.id),
    queryFn: () => companyService.getCompanyServices(currentCompany.id),
    refetchOnWindowFocus: false,
  })
}

export function useInvalidateCurrentCompanyServicesQuery() {
  const queryClient = useQueryClient()
  const currentCompany = useCurrentCompanyOrFail()

  return () => {
    queryClient.invalidateQueries({
      queryKey: QUERY_KEYS.companyServices(currentCompany.id),
    })
  }
}
